import { routes as professional } from './professional'
import { routes as company } from './company'

export default [
  ...professional,
  ...company
]



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/routes.js